import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../../components/survey/index'// 报表上报记录

Vue.use(VueRouter)

const routes = [{
  path: '/:surveyId/:surveyType',
  component: index
}]

// 3. 创建和挂载根实例。
// 记得要通过 router 配置参数注入路由，
// 从而让整个应用都有路由功能
export default new VueRouter({
  routes: routes
})



// WEBPACK FOOTER //
// ./src/router/survey/survey.js